import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'ship',
  size: 24,
  node: [
    ['path', { d: 'M12 2v2', key: 'tus03m' }],
    ['path', { d: 'M12 9.189V13', key: 'yp40p3' }],
    ['path', { d: 'M19 12V6a2 2 0 00-2-2H7a2 2 0 00-2 2v6', key: '1wcigf' }],
    [
      'path',
      {
        d: 'M19.38 19A11.6 11.6 0 0021 13l-8.188-3.639a2 2 0 00-1.624 0L3 13.001a11.6 11.6 0 002.81 7.76',
        key: '1kdp0u',
      },
    ],
    [
      'path',
      {
        d: 'M2 20c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1',
        key: '1l8w7g',
      },
    ],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name Ship
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMnYyIiAvPgogIDxwYXRoIGQ9Ik0xMiA5LjE4OVYxMyIgLz4KICA8cGF0aCBkPSJNMTkgMTJWNmEyIDIgMCAwMC0yLTJIN2EyIDIgMCAwMC0yIDJ2NiIgLz4KICA8cGF0aCBkPSJNMTkuMzggMTlBMTEuNiAxMS42IDAgMDAyMSAxM2wtOC4xODgtMy42MzlhMiAyIDAgMDAtMS42MjQgMEwzIDEzLjAwMWExMS42IDExLjYgMCAwMDIuODEgNy43NiIgLz4KICA8cGF0aCBkPSJNMiAyMGMuNi41IDEuMiAxIDIuNSAxIDIuNSAwIDIuNS0yIDUtMiAxLjMgMCAxLjkuNSAyLjUgMXMxLjIgMSAyLjUgMWMyLjUgMCAyLjUtMiA1LTIgMS4zIDAgMS45LjUgMi41IDEiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/ship
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Ship = createLucideIcon(__iconData);

export default Ship;
